const timer = document.querySelector("#countdown-timer");
const banner = document.querySelector('header .promo-banner__wrapper');

if (timer) {
  const timeData = timer.getAttribute("js-countdown-data");
  const jsonTimeData = JSON.parse(timeData);
  const starttime = jsonTimeData.starttime;
  const endtime = jsonTimeData.endtime;

  function addZero(value) {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  function visibility(selector, status) {
    if (status === "active") {
      document.querySelector(selector).style.display = "block";
    } else {
      document.querySelector(selector).style.display = "none";
    }
  }

  if (endtime.length > 0) {
    const countDownDate = new Date(endtime).getTime();
    const startDate = new Date(starttime).getTime();
    const checker = setInterval(function () {
      // Get todays date and time
      const now = new Date().getTime();
      if (now >= countDownDate) {
        visibility(".promo-banner__wrapper", "inactive");
        clearInterval(checker);
      } else if (now < startDate) {
        visibility(".promo-banner__wrapper", "inactive");
      } else {
        visibility(".promo-banner__wrapper", "active");
        // Find the distance between sart date and the count down date
        let distance = countDownDate - now;
        if (startDate > now) {
          distance = countDownDate - startDate;
        }

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        days = addZero(days);

        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        hours = addZero(hours);

        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        minutes = addZero(minutes);

        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        seconds = addZero(seconds);

        document.querySelector(".js-days").innerText = days;
        document.querySelector(".js-hours").innerText = hours;
        document.querySelector(".js-minutes").innerText = minutes;
        document.querySelector(".js-seconds").innerText = seconds;
        
        banner.style.opacity = '1';
        
        if (distance < 0) {
          clearInterval(checker);
          document.getElementById("js_set_time").innerHTML = "Out of date";
          visibility(".countdown__wrap", "inactive");
        }
      }
    }, 1000);
  }
}
